import type { CollectionData } from '@adapters/prismic/types/plp';
import type {
  PlpCategoryNavigationData,
  PlpCategoryNavigationPlacement,
} from '@adapters/prismic/transforms/categoryNavigationTiles';
import { FEATURE_FLAG_CATEGORY_NAVIGATION_TILES } from '@config/feature-flag';

type CategoryNavigationSource =
  | Pick<CollectionData, 'categoryNavigation'>
  | null
  | undefined;

const getCategoryNavigationPlacedAt =
  (placement: PlpCategoryNavigationPlacement) =>
  (source: CategoryNavigationSource): PlpCategoryNavigationData | null => {
    const navigation = source?.categoryNavigation;

    return FEATURE_FLAG_CATEGORY_NAVIGATION_TILES &&
      navigation?.placement === placement
      ? navigation
      : null;
  };

/**
 * The ED-218 Category Navigation Tiles that render in the PLP Header directly
 * under the h1, before the deals: only when the flag is on and merch chose the
 * "above results" placement.
 */
export const getCategoryNavigationAboveResults =
  getCategoryNavigationPlacedAt('aboveResults');

/**
 * The ED-218 Category Navigation Tiles that render in the PLP Header after
 * the deals strips: only when the flag is on and merch chose the "above
 * results, after deals" placement. "Below results" renders on the page itself.
 */
export const getCategoryNavigationAfterDeals = getCategoryNavigationPlacedAt(
  'aboveResultsAfterDeals'
);
